(() => {
  if (customElements.get('ts-lug-count-help')) return;
  // Page-lifetime deduplication only. No cookies, storage, or customer identifiers.
  const impressions = new Set();
  class LugCountHelp extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('.ts-lug-help__trigger');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.trigger.hidden = false;
      this.setupMeasurement(options);
      this.trigger.addEventListener('click', () => {
        if (this.dialog.open) return;
        this.measureImpression();
        this.previousFocus = document.activeElement;
        this.previousOverflow = document.body.style.overflow;
        this.dialog.showModal();
        this.emitMeasurement('lug_guide_open');
        document.body.style.overflow = 'hidden';
        this.querySelector('[data-lug-close]').focus({ preventScroll: true });
      }, options);
      const finder = this.querySelector('[data-lug-finder]');
      if (finder) finder.addEventListener('click', event => {
        if (!this.dialog.open) return;
        this.emitMeasurement('lug_guide_finder_click');
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const compact = [...document.querySelectorAll('.ts-compact-vehicle__details')].find(el => el.getClientRects().length);
        if (!compact) return; // Keep the real homepage finder link as a navigation fallback.
        event.preventDefault();
        this.previousFocus = null; // The destination receives focus instead of the modal trigger.
        this.dialog.close();
        this.restore();
        compact.open = true;
        compact.scrollIntoView({ block: 'center', behavior: 'auto' });
        const year = [...compact.querySelectorAll('select.ymm-filter:not([disabled])')].find(el => el.getClientRects().length);
        (year || compact.querySelector('summary'))?.focus({ preventScroll: true });
      }, options);
      this.querySelector('[data-lug-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('cancel', event => {
        event.preventDefault();
        this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => this.restore(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const items = [...this.dialog.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex="0"]')].filter(el => el.getClientRects().length);
        const first = items[0], last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      }, options);
    }
    analyticsAllowed() {
      try {
        return !window.Shopify?.designMode &&
          window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
      } catch (_) { return false; }
    }
    emitMeasurement(event) {
      if (!this.isConnected || !this.dataset.productId || !this.analyticsAllowed()) return false;
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event,
          product_id: this.dataset.productId,
          product_handle: this.dataset.productHandle,
          guide_version: this.dataset.guideVersion
        });
        return true;
      } catch (_) { return false; }
    }
    measureImpression() {
      const key = `${location.pathname}:${this.dataset.productId}`;
      if (impressions.has(key) || this.trigger.hidden || this.dialog.open ||
          document.visibilityState !== 'visible' || !this.trigger.getClientRects().length) return;
      const rect = this.trigger.getBoundingClientRect();
      const visibleWidth = Math.max(0, Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0));
      const visibleHeight = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
      if (rect.width <= 0 || rect.height <= 0 || visibleWidth * visibleHeight < rect.width * rect.height * 0.5) return;
      if (this.emitMeasurement('lug_guide_impression')) impressions.add(key);
    }
    setupMeasurement(options) {
      const measure = () => this.measureImpression();
      if ('IntersectionObserver' in window) {
        this.impressionObserver = new IntersectionObserver(measure, { threshold: 0.5 });
        this.impressionObserver.observe(this.trigger);
      }
      // A consent grant may count current exposure, but never replays earlier actions.
      document.addEventListener(window.tsRegisterAnalyticsConsentCallback ? 'ts:analytics-consent-synced' : 'visitorConsentCollected', measure, options);
      document.addEventListener('visibilitychange', measure, options);
      this.dialog.addEventListener('close', measure, options);
      if (!window.tsRegisterAnalyticsConsentCallback && !window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
        const signal = this.controller.signal;
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => {
          if (!error && !signal.aborted) measure();
        });
      }
      measure();
    }
    restore() {
      if (this.previousOverflow !== undefined) document.body.style.overflow = this.previousOverflow;
      this.previousOverflow = undefined;
      if (this.previousFocus && this.previousFocus.isConnected) this.previousFocus.focus({ preventScroll: true });
      this.previousFocus = null;
    }
    disconnectedCallback() {
      if (this.impressionObserver) this.impressionObserver.disconnect();
      this.impressionObserver = null;
      if (this.dialog && this.dialog.open) this.dialog.close();
      this.restore();
      if (this.controller) this.controller.abort();
      this.controller = null;
    }
  }
  customElements.define('ts-lug-count-help', LugCountHelp);
})();

